<template>
  <div>
    <v-overlay-intro />
    <v-dialog-intro :dialogItems="schema.dialogItems" />
    <main-header-info :navInfoItems="schema.navInfoItems" id="banner" />
    <home-banner :bannerItems="schema.bannerItems" />
    <v-row id="services">
      <v-slides-services
        :services="schema.services"
        :length="schema.servicesLength"
        :servicesIcons="schema.servicesIcons"
      />
    </v-row>
    <v-row id="contact">
      <v-col>
        <v-card-footer
          :footerItems="schema.footerItems"
          :legalItems="schema.legalItems"
          :contactItems="schema.contactItems"
          :socialNetItems="schema.socialNetItems"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VOverlayIntro from '@/components/base/VOverlayIntro.vue';
import VDialogIntro from '@/components/base/VDialogIntro.vue';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import HomeBanner from '@/components/home/Banner.vue';
import VSlidesServices from '@/components/base/VSlidesServices.vue';
import VCardFooter from '@/components/base/VCardFooter.vue';

export default {
  name: 'HomePro',
  components: {
    VOverlayIntro,
    VDialogIntro,
    MainHeaderInfo,
    HomeBanner,
    VSlidesServices,
    VCardFooter,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('homeProPage', ['schema']),
  },
  methods: {
    ...mapActions('homeProPage', ['loadSchema']),
  },
};
</script>
